import {
  useLocation,
  useNavigate,
  useParams as rrUseParams,
  useSearchParams as rrUseSearchParams,
} from "react-router-dom";

type NavOpts = { scroll?: boolean };

export function useRouter() {
  const navigate = useNavigate();
  return {
    push: (to: string, _opts?: NavOpts) => navigate(to),
    replace: (to: string, _opts?: NavOpts) => navigate(to, { replace: true }),
    back: () => navigate(-1),
    forward: () => navigate(1),
    refresh: () => window.location.reload(),
  };
}

export function usePathname() {
  const loc = useLocation();
  return loc.pathname;
}

export function useParams<T extends Record<string, string | undefined>>() {
  return rrUseParams() as T;
}

export function useSearchParams() {
  const [sp] = rrUseSearchParams();
  return sp;
}
